<div class="grafana-container">
  <iframe
    [src]="url | sensorstationsUrl"
    width="100%" height="545"
      frameborder="0">
    </iframe>
  </div>
  